import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filename'
})
export class FilenamePipe implements PipeTransform {

    transform(value: string): string {
        if (!value) {
            return '';
        }
        // Remove the "Sessions//" prefix and return the file name
        return value.replace(/^Sessions\/\//, '');

    }

}